import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
//import { RolesService } from '../services/roles/roles.service';

const DEFAULT_PASSPHRASE = "@GBL#EINV@";

@Injectable()
export class EncryptDecryptService {
  constructor() {
    // SOme Code
  }
  public passPhrase = DEFAULT_PASSPHRASE;
  public isPassPhraseSet = false;
  public readonly salt = CryptoJS.lib.WordArray.random(128/8).toString(CryptoJS.enc.Hex);
  public readonly iv = CryptoJS.lib.WordArray.random(128/8).toString(CryptoJS.enc.Hex);
  public readonly keySize = 128 / 32;
  public readonly iterationCount = 1000;

  setPassPhrase(passPhrase: string): void {
    this.passPhrase = passPhrase;
    this.isPassPhraseSet = true;
  }

  hasPassPhrase(): boolean {
    return this.isPassPhraseSet;
  }

  resetPassPhrase(): void {
    this.passPhrase = DEFAULT_PASSPHRASE;
    this.isPassPhraseSet = false;
  }

  generateKey(salt: string, passPhrase: string) {
    let key = CryptoJS.PBKDF2(
        passPhrase,
        CryptoJS.enc.Hex.parse(salt),
        { keySize: this.keySize, hasher: CryptoJS.algo.SHA1, iterations: this.iterationCount});
    return key;
  }
  private encryptProcess<String>(data, defaultPassPhrase) {
    let key = defaultPassPhrase ? this.generateKey(this.salt, DEFAULT_PASSPHRASE)
      : this.generateKey(this.salt, this.passPhrase);
    let encrypted = CryptoJS.AES.encrypt(
        data,
        key,
        { iv: CryptoJS.enc.Hex.parse(this.iv) });

    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  private decryptProcess<String>(iv: string, salt: string, encryptedData: any, defaultPassPhrase) {
    let key = defaultPassPhrase ? this.generateKey(salt, DEFAULT_PASSPHRASE) : this.generateKey(salt, this.passPhrase);
    let cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptedData)
    });
    let decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        key,
        { iv: CryptoJS.enc.Hex.parse(iv) });
    return decrypted?.toString(CryptoJS.enc.Utf8);
  }

  public encrypt(plainText: any) {
    //plainText = btoa(plainText);
    return btoa(this.iv + "::" + this.salt + "::" + this.encryptProcess("" + plainText, false));
  }

  public encryptWithDefault(plainText: any) {
    //plainText = btoa(plainText);
    return btoa(this.iv + "::" + this.salt + "::" + this.encryptProcess("" + plainText, true));
  }

  public decrypt(encrypted: string) {
    const decoded = atob(encrypted);
    const splitted = decoded.split("::")

    let decrypted =  this.decryptProcess(splitted[0], splitted[1], splitted[2], false);
    return decrypted;
    //return atob(decrypted);
  }

  public decryptWithDefault(encrypted: string) {
    const decoded = atob(encrypted);
    const splitted = decoded.split("::")

    let decrypted =  this.decryptProcess(splitted[0], splitted[1], splitted[2], true);
    return decrypted;
    //return atob(decrypted);
  }

  public encode(value : string) {
      return btoa(value);
  }

  public decode(value : string) {
      return atob(value);
  }

  public encodeEmail(value:string){
    return window.btoa(unescape(encodeURIComponent(value)));
  }

  public decodeEmail(value:string){
    return decodeURIComponent(escape(window.atob(value)));
  }


}
